import { createSlice } from "@reduxjs/toolkit";
import {
  getAllCompletedKorba,
  getAllKorba,
  getAllKorbaAssistance,
  getAllKorbaTypes,
  getDetailsKorba,
  getKorbaHomePage,
} from "../actions/korba.actions";

const initialState = {
  korbaTypes: [] as any,
  completedkorba: [] as any,
  korbaAssitances: [] as any,
  korbaHomePage: [] as any,
  statusKorba: "idle" as string,
  korbas: [] as any,
  detailsKorba: null as any,
  loading: false,
  error: null as unknown | null,
};
export const korbaSlice = createSlice({
  name: "korbas",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getAllKorba.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllKorba.fulfilled, (state, action) => {
        state.korbas = action.payload;
        state.loading = false;
      })
      .addCase(getAllKorba.rejected, (state, action) => {
        state.korbas = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllKorbaTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllKorbaTypes.fulfilled, (state, action) => {
        state.korbaTypes = action.payload;
        state.loading = false;
      })
      .addCase(getAllKorbaTypes.rejected, (state, action) => {
        state.korbaTypes = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllCompletedKorba.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCompletedKorba.fulfilled, (state, action) => {
        state.completedkorba = action.payload;
        state.loading = false;
      })
      .addCase(getAllCompletedKorba.rejected, (state, action) => {
        state.completedkorba = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllKorbaAssistance.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllKorbaAssistance.fulfilled, (state, action) => {
        state.korbaAssitances = action.payload;
        state.loading = false;
      })
      .addCase(getAllKorbaAssistance.rejected, (state, action) => {
        state.korbaAssitances = [];
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getKorbaHomePage.pending, (state) => {
        state.statusKorba = "idle";
      })
      .addCase(getKorbaHomePage.fulfilled, (state, action) => {
        state.korbaHomePage = action.payload;
        state.statusKorba = "succeeded";
      })
      .addCase(getKorbaHomePage.rejected, (state, action) => {
        state.korbaHomePage = [];
        state.statusKorba = "rejected";
        state.error = action.payload;
      })

      .addCase(getDetailsKorba.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDetailsKorba.fulfilled, (state, action) => {
        state.detailsKorba = action.payload.result;
        state.loading = false;
      })
      .addCase(getDetailsKorba.rejected, (state, action) => {
        state.detailsKorba = null;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default korbaSlice.reducer;
